import { render } from "./Video.vue.js?vue&type=template&id=88294562!=!../vue-loader/dist/index.js??ruleSet[0]!./Video.vue?vue&type=template&id=88294562"
import script from "./Video.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Video.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__